import type { QueryClient, QueryFilters } from '@tanstack/react-query'
import type { useTRPC } from '@/trpc/react.ts'

/** 财务变更会影响订单余额与租赁占用；备注编辑只影响账单自身。 */
export async function refreshMoneyQueries(
  cache: QueryClient,
  trpc: ReturnType<typeof useTRPC>,
  scope: 'finance' | 'notes' = 'finance'
) {
  const filters: QueryFilters[] = [trpc.bill.list.queryFilter(), trpc.bill.detail.queryFilter()]
  if (scope === 'finance') {
    filters.push(
      trpc.bill.groupList.queryFilter(),
      trpc.bill.groupDetail.queryFilter(),
      trpc.bill.groupBatchTargets.queryFilter(),
      trpc.bill.groupRevisions.queryFilter(),
      trpc.bill.candidates.queryFilter(),
      trpc.bill.refundable.queryFilter(),
      trpc.bill.previewMonthlyGroup.queryFilter(),
      trpc.bill.previewCustomerIssue.queryFilter(),
      trpc.bill.previewCustomerSend.queryFilter(),
      trpc.bill.moneyList.queryFilter(),
      trpc.bill.moneyDetail.queryFilter(),
      trpc.bill.cashReport.queryFilter(),
      trpc.bill.analysis.queryFilter(),
      trpc.analytics.summary.queryFilter(),
      trpc.analytics.list.queryFilter(),
      trpc.order.rental.list.queryFilter(),
      trpc.order.rental.detail.queryFilter(),
      trpc.order.service.list.queryFilter(),
      trpc.order.service.detail.queryFilter(),
      trpc.order.groups.detail.queryFilter(),
      trpc.room.list.queryFilter(),
      trpc.room.tree.queryFilter(),
      trpc.room.recommend.queryFilter(),
      trpc.room.availableOptions.queryFilter()
    )
  }
  await Promise.all(filters.map((filter) => cache.invalidateQueries(filter)))
}
